var map = {
	"./2CShop.png": "1a59",
	"./All value.png": "2bf3",
	"./Amazon.png": "9684",
	"./Android.png": "1879",
	"./Funpinpin.png": "8d5c",
	"./IOS.png": "1e5d",
	"./Magento.png": "5049",
	"./Meshop.png": "76a2",
	"./Opencart.png": "91d8",
	"./Shopbase.png": "9dca",
	"./Shopexpress.png": "dde0",
	"./Shopify.png": "d89a",
	"./Shoplazza.png": "dfdf",
	"./Shopline.png": "3144",
	"./Shoplus.png": "a0ea",
	"./Shoptop.png": "099c",
	"./Shopyy.png": "89f5",
	"./Ueeshop.png": "8573",
	"./Woocommerce.png": "e775",
	"./WordPress.png": "5d61",
	"./Xshoppy.png": "f62d",
	"./default.png": "434d",
	"./华为.png": "1517",
	"./小渔夫.png": "f6b48",
	"./紫鸟.png": "d8e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a75e";